import React from "react";

import { NFL_TEAMS } from "./nfl";

export default function TeamColorsDebug() {
  return (
    <table style={{ borderSpacing: 6 }}>
      <tbody>
        {Object.values(NFL_TEAMS).map(team => (
          <tr>
            <td>{team.short}</td>
            <td>{team.name}</td>
            <td>{team.city}</td>
            <td
              style={{ width: 60, height: 30, backgroundColor: team.primaryColor }}
              title={team.primaryColor}
            />
            <td
              style={{ width: 60, height: 30, backgroundColor: team.secondaryColor }}
              title={team.secondaryColor}
            />
          </tr>
        ))}
      </tbody>
    </table>
  );
}



// WEBPACK FOOTER //
// ./src/TeamColorsDebug.js